var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTomaDatos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.643 7.133l-.26.252-2.207-2.138.262-.254a1.448 1.448 0 011.998.002l.207.2a1.343 1.343 0 010 1.938zm-3.227 10.502c0 .757-.634 1.37-1.414 1.37H4.357c-.78 0-1.413-.613-1.414-1.37V2.285c0-.757.633-1.37 1.414-1.371h11.645c.78 0 1.413.614 1.414 1.37V4.69l-7.275 7.032a.454.454 0 00-.123.207L8.98 15.742a.447.447 0 00.123.44c.119.114.292.16.454.118l3.907-1.005a.474.474 0 00.213-.119l3.738-3.623v6.082zm-4.07-3.43l-2.207-2.157 6.369-6.156 2.208 2.14-6.37 6.174zm-2.627-1.27l1.717 1.679-2.337.601.62-2.28zm10.384-8.587a2.418 2.418 0 00-2.744-.416V2.284C18.357 1.024 17.303.001 16.002 0H4.357C3.056 0 2.002 1.024 2 2.284v15.35c.002 1.262 1.056 2.284 2.357 2.285h11.645c1.3-.001 2.355-1.023 2.357-2.284v-6.996l2.95-2.86c.921-.892.921-2.338 0-3.23l-.206-.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTomaDatos);
export default __webpack_public_path__ + "static/media/icon_tomaDatos.385f6a6405814dda42be1f4d3803b610.svg";
export { ForwardRef as ReactComponent };